import { DatePicker, TimePicker } from 'antd';
import { Button, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import axios from 'axios';
import React, { useState ,useEffect } from 'react'
import { toast } from 'react-toastify';
import "../MainCSS.css";
import "aos/dist/aos.css";
import { RackMasterGet } from '../../AllAPI/MasterAPI/ProductionMasterApi';
import { GetAgegingData, GetRackData, GetRackNumberData, SaveAgegingData, SaveCompletedAgegingData } from '../../AllAPI/ProductionAPI/ProductionApi';
import dayjs from 'dayjs';

const Ageins = () => {
  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  };

   const [errors, setErrors] = useState({
      rackNumber: "",
      agegingNo: "",
      agegingDate:"",
      agegingStartTime:"",
      agegingOutTime:"",
      agegingTempTime:"",
      remark:"",

  
    });
    const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']
    const [pageSize, setPageSize] = useState(10);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
  
    const [remark, setRemark] = useState("");
    const [rackNumber, setRackNumber] = useState([]);
    const [agegingNo, setAgegingNo] = useState("");
    const [agegingDate, setAgegingDate] = useState(dayjs());
    const [agegingStartTime, setAgegingStartTime] = useState(dayjs());
    const [agegingOutTime, setAgegingOutTime] = useState(dayjs());
    const [agegingTempTime, setAgegingTempTime] = useState(dayjs());
    const [srNo, setSrNo] = useState(null); 
    const [SelectedAgegingNo, setSelectedAgegingNo] = useState("");




    const [allrack, setAllRack] = useState([]);
     const [allrackNumbers, setAllRackNumbers] = useState([]);
    const [allAgeging, setAllAgeging] = useState([]);

    const [submitButton, setSubmitButton] = useState(true);
    const [updateButton, setUpdateButton] = useState(false);
    const[completeButton,setCompleteButton]=useState(false);
  
    //======Search data from table===============
      const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
  
      const filtered = allAgeging.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );

      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
    //==========Pagination=======================
    const handlePageSizeChange = (value) => {
      setPageSize(value);
    };
  
   
   // ==============Get table data================
    let isAgegingFetched = false;
    useEffect(() => {
      if (isAgegingFetched) return;
          fetchAgeging();
          fetchRackMaster();
           fetchRackNumberMaster();
      isAgegingFetched = true;
    }, []);
  
    let isError = false;
  
    const fetchRackNumberMaster = async () => {
      try {
        const response = await axios.get(GetRackNumberData , commonHeaders);

        if (response.data !== null) {
          setAllRackNumbers(response.data);
         
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Rack Master data:", error);
          toast.error("Failed to fetch Rack Master data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
        const fetchRackMaster = async () => {
      try {
        const response = await axios.get(RackMasterGet , commonHeaders);

        if (response.data !== null) {
          setAllRack(response.data);
         
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Rack Master data:", error);
          toast.error("Failed to fetch Rack Master data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
    const fetchAgeging = async () => {
      try {
        const response = await axios.get(GetAgegingData , commonHeaders);
        
 if (response.data && response.data.length > 0) {
            setAllAgeging(response.data);
          setFilteredData(response.data);
          setTotalEntries(response.data.length);
        }
        else{
          toast.warn("Data not available !!");
           setAllAgeging([]);
          setFilteredData([]);
          setTotalEntries([]);
        }
        // const data = response.data;

        // if (data && data.length > 0) {
        //   const maxAgegingNo = Math.max(
        //     ...data.map((item) => Number(item.ageingNumber || 0))
        //   );
        //   setAgegingNo((maxAgegingNo + 1).toString());
        // } else {
        //   setAgegingNo("1");
        // }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching  data:", error);
          toast.error("Failed to fetch  data");
          isError = true; 
        }
      }
    };
  const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Ageing Number",
    dataIndex: "ageingNumber",
    key: "ageingNumber",
    sorter: (a, b) => {
      // If it's a number:
      return a.ageingNumber - b.ageingNumber;
      // If it's a string:
      //return a.ageingNumber?.localeCompare(b.ageingNumber);
    },
  },
  {
    title: "Ageing Date",
    dataIndex: "ageingDate",
    key: "ageingDate",
    sorter: (a, b) => new Date(a.ageingDate) - new Date(b.ageingDate),
  },
  {
    title: "Rack Number",
    dataIndex: "rackNumbers",
    key: "rackNumbers",
        render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,

    sorter: (a, b) => {
      // If it's a number:
      return a.rackNumbers - b.rackNumbers;
      // If it's a string:
      // return a.rackNumbers?.localeCompare(b.rackNumbers);
    },
  },
  {
    title: "Start Time",
    dataIndex: "startTime",
    key: "startTime",
    sorter: (a, b) => new Date(`1970-01-01T${a.startTime}`) - new Date(`1970-01-01T${b.startTime}`),
  },
  {
    title: "Temp Acheive Time",
    dataIndex: "temperatureAchieveTime",
    key: "temperatureAchieveTime",
    sorter: (a, b) => new Date(`1970-01-01T${a.temperatureAchieveTime}`) - new Date(`1970-01-01T${b.temperatureAchieveTime}`),
  },
  {
    title: "Out Time",
    dataIndex: "outTime",
    key: "outTime",
    sorter: (a, b) => new Date(`1970-01-01T${a.outTime}`) - new Date(`1970-01-01T${b.outTime}`),
  },
  {
    title: "Remark",
    dataIndex: "remark",
    key: "remark",
    sorter: (a, b) => a.remark?.localeCompare(b.remark),
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        {record.ageingDone !== 1 && (
          <Button
            type="submit"
            style={{ fontSize: "12px", backgroundColor: "#349ff3", marginRight: "10px" }}
            onClick={() => {
              setCompleteButton(true);
              setSubmitButton(false);
              handleCompleteDataButton(record);
            }}
          >
            Complete
          </Button>
        )}
      </div>
    ),
  },
];

  
    const components = {
      header: {
        cell: ({ children, ...restProps }) => (
          <th
            {...restProps}
            style={{
              backgroundColor: "#023e7d",
              color: "#fff",
              padding: "10px",
              fontSize: "15px",
              borderRadius: "0px",
            }}
          >
            {children}
          </th>
        ),
      },
      body: {
        row: ({ children, ...restProps }) => (
          <tr
            {...restProps}
            style={{
              backgroundColor: "#f0f7fd",
            }}
          >
            {children}
          </tr>
        ),
        cell: ({ children, ...restProps }) => (
          <td
            {...restProps}
            style={{
              padding: "8px",
                    fontSize: '15px',

            }}
          >
            {children}
          </td>
        ),
      },
    };

  // ========Submit data to table==============
  const handleSubmit = async () => {
    let isValid = true;
    const errorObj = {};
  
    if (!rackNumber) {
      isValid = false;
      errorObj.rackNumber = "Rack Number is required *";
    }
  
    if (!agegingDate) {
      isValid = false;
      errorObj.agegingDate = "Ageging Date is required *";
    }
  
    if (!agegingStartTime) {
      isValid = false;
      errorObj.agegingStartTime = "Ageging Time is required *";
    }
  
    setErrors(errorObj); // Show error messages
  
    if (!isValid) return;
  
    const bodyData = {
      ageingDate: dayjs(agegingDate).format("YYYY-MM-DD"),
      startTime: dayjs(agegingStartTime).format("HH:mm:ss"),
      rackNumberIds: rackNumber
    };
  
    try {
      const response = await axios.post(SaveAgegingData, bodyData, commonHeaders);
  
      if (response.data === "CREATED") {
        toast.success("Ageging Data added successfully!");
        fetchAgeging();
        handleCancel();
      } else if (response.data === "ALREADYEXISTED") {
        toast.warn("Ageging data already exist!");
      }
      else if (response.data === "RACK_NOT_FOUND") {
        toast.warn("Rack Not found!");
      }
      
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error occurred while submitting data");
    }
  };
    //==================== Handle Cancel button =====================
    const handleCancel = () => {
      setUpdateButton(false);
      setSubmitButton(true);
       setAgegingNo("");
      setRackNumber("");
      setAgegingDate(dayjs());
      setAgegingStartTime(dayjs());
      setAgegingOutTime(dayjs());
      setAgegingTempTime(dayjs());
      setRemark("");
      setCompleteButton(false);
      setErrors("");
    };
   
    const handleCompleteDataButton = (item) =>{
      setSelectedAgegingNo(item.ageingNumber);
      setAgegingDate(dayjs(item.agegingDate));
      // setRackNumber(item.rackNumberIds);
      const rackIds = item.rackNumberIds
    ? item.rackNumberIds.split(',').map(Number)
    : [];
  setRackNumber(rackIds);
    }

  //   useEffect(() => {
  //     // Ensure rackNumber is not empty before calculating agegingNo
  //     if (!rackNumber) return;
  
  //     // Get the last two digits of the current year (e.g., 2025 -> "25")
  //     const year = new Date().getFullYear().toString().slice(-2);
  
  //     // Filter the records based on the actual rack number (not rackNumberId)
  //     const rackAgegingData = allAgeging.filter(item => item.rackNumberId === rackNumber);
  //     // console.log("Ageging Data :",rackAgegingData);
  //     // console.log("Rack Number : " ,rackNumber);
  //     // Default the serial number to 1 if no data exists for the rack
  //     const newSrNo = rackAgegingData.length + 1;

  // setSrNo(newSrNo);
  //     const rackDetails = allrack.find(rack => rack.rackNumberId === rackNumber);
  //     console.log("Rack Details : " ,rackDetails);
  //     const rackNumberStr = String(rackDetails?.rackNumber || ''); // Safely handle case if rackDetails is undefined

  //     const newAgegingNo = `${year}${rackNumberStr.padStart(3, '0')}${newSrNo.toString().padStart(3, '0')}`;
  //     // console.log("Ageging No. : " ,newAgegingNo);

  //     setAgegingNo(newAgegingNo);  // Update the agegingNo state
  
  //   }, [rackNumber, allAgeging]);
 
  
  
     // ========Submit  Completed Ageging data to table ==============
  const handleCompleteSubmit = async () => {
    let isValid = true;
    const errorObj = {};
  
    if (!remark) {
      isValid = false;
      errorObj.remark = "Remark is required *";
    }
  
  
    if (!agegingTempTime) {
      isValid = false;
      errorObj.agegingTempTime = "Time is required *";
    }
  
    if (!agegingOutTime) {
      isValid = false;
      errorObj.agegingOutTime = "Time is required *";
    }
  
    setErrors(errorObj); // Show error messages
  
    if (!isValid) return;
  
    const bodyData = {
      outTime: dayjs(agegingOutTime).format("HH:mm:ss"),
    temperatureAchieveTime: dayjs(agegingTempTime).format("HH:mm:ss"),
    remark : remark,
    ageingNumber:SelectedAgegingNo,
    // rackNumbers: rackNumber
    // .split(',')
    // .map(num => parseFloat(num.trim()))
      rackNumbers: rackNumber,
    };
  
    try {
      const response = await axios.post(SaveCompletedAgegingData, bodyData, commonHeaders);
  
      if (response.data === "COMPLETED") {
        toast.success("Ageging Data added successfully!");
        fetchAgeging();
        handleCancel();
      } else if (response.data === "ALREADYCOMPLETED") {
        toast.warn("Ageging  already completed!");
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error occurred while submitting data");
    }
  };
  useEffect(() => {
    if (!allAgeging || allAgeging.length === 0) return;
  
    const year = new Date().getFullYear().toString().slice(-2); // e.g., "25"
  
    const yearWiseNos = allAgeging
      .map(item => item.ageingNumber?.toString()) // corrected field and type
      .filter(no => no && no.startsWith(year));
  
    // console.log("Filtered AGEGING Nos:", yearWiseNos);
  
    const serials = yearWiseNos.map(no => parseFloat(no.slice(2))); // extract serial part
    const maxSerial = serials.length > 0 ? Math.max(...serials) : 0;
  
    const nextSerial = maxSerial + 1;
    const newAgegingNo = `${year}${nextSerial.toString().padStart(4, '0')}`;
  
    // console.log("Setting AGEGING No to:", newAgegingNo);
  
    setSrNo(nextSerial);
    setAgegingNo(newAgegingNo);
  }, [allAgeging]);
  
  
   
  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
  <div className="col-12">


 
    <div className="p-0 m-0">
  
   <div className="row px-md-5 mt-3 p-2 ">
   
      <div className="row p-0 m-0">
      <div className="col-12 col-lg-4"></div>
      {!completeButton && (  
      <div className="col-12 col-lg-4">
      <div className="row p-0 m-0">
      
      <div className="col-12 py-1">
        <label className="labels">AGEING Number </label>
        <Input
        value={agegingNo}
        readOnly
        style={{ width: "100%", backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
      />
        {errors.agegingNo && <div className="errorField">{errors.agegingNo}</div>}
      </div>
      <div className="col-12 py-1">
        <label className="labels">Rack Number</label>
        <Select
    mode="multiple"
    value={rackNumber}
    onChange={(value) => setRackNumber(value)}
    placeholder="Select Rack Numbers"
    style={{ width: '100%' }}
    showSearch
    optionFilterProp="children"

  >
   {allrackNumbers
    .filter((rack) => rack.rackNumberId !== null && rack.rackNumberId !== undefined)
    .map((rack) => (
      <Option key={rack.rackNumberId} value={rack.rackNumberId}>
        {rack.rackNumber}
      </Option>
    ))}
  </Select>
        {errors.rackNumber && <div className="errorField">{errors.rackNumber}</div>}
      </div>

      <div className="col-12 py-1">
        <label className="labels">AGEING Date </label>
        <DatePicker
          value={agegingDate}
          onChange={(value) => setAgegingDate(value)}
                                format={dateFormatList}

          placeholder="Select Ageging"
          style={{ width: '100%' }}
         
        />
         
        {errors.agegingDate && <div className="errorField">{errors.agegingDate}</div>}
      </div>
      <div className="col-12 py-1">
        <label className="labels">AGEING Start Time </label>
        <TimePicker
          value={agegingStartTime}
          onChange={(value) => setAgegingStartTime(value)}
          placeholder="Select Ageging"
//renderExtraFooter={() => <div style={{ width: '300px' }} />}
      
                style={{ width: '100%', }}

        />
         
        {errors.agegingStartTime && <div className="errorField">{errors.agegingStartTime}</div>}
      </div>
    
     
  </div>
  </div>)}
  {completeButton && (      <div className="col-12 col-lg-4">
      <div className="row p-0 m-0">
      
      <div className="col-12 py-1">
        <label className="labels">AGEING Number </label>
        <Input
        value={SelectedAgegingNo}
        
        readOnly
        style={{ width: "100%", backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
      />
        {errors.agegingNo && <div className="errorField">{errors.agegingNo}</div>}
      </div>
      <div className="col-12 py-1">
        <label className="labels">AGEING Date </label>
        <DatePicker
          value={agegingDate}
                                format={dateFormatList}

        inputReadOnly={true} // makes input uneditable
  open={false}         // stops calendar from opening
  style={{ width: '100%', backgroundColor: '#f5f5f5' }} 
        />
         
        {errors.agegingDate && <div className="errorField">{errors.agegingDate}</div>}
      </div>
      <div className="col-12 py-1">
        <label className="labels">Rack Number</label>
        <Select
    mode="multiple"
    value={rackNumber}
  open={false}
    // onChange={(value) => setRackNumber(value)}
    placeholder="Select Rack Numbers"
  style={{ width: '100%', backgroundColor: '#f5f5f5' }} 
aria-readonly  >
    {allrack
    .filter((rack) => rack.id !== null && rack.id !== undefined)
    .map((rack) => (
      <Option key={rack.id} value={rack.id}>
        {rack.rackNumber}
      </Option>
    ))}
  </Select>
        {errors.rackNumber && <div className="errorField">{errors.rackNumber}</div>}
      </div>
      
      <div className="col-12 py-1">
        <label className="labels">AGEING Out Time </label>
        <TimePicker
          value={agegingOutTime}
          onChange={(value) => setAgegingOutTime(value)}
          placeholder="Select Ageging"
          style={{ width: '100%' }}
           showSearch
                optionFilterProp="label"
        />
         
        {errors.agegingOutTime && <div className="errorField">{errors.agegingOutTime}</div>}
      </div>
      <div className="col-12 py-1">
        <label className="labels">AGEING Tempearture Achieve Time </label>
        <TimePicker
          value={agegingTempTime}
          onChange={(value) => setAgegingTempTime(value)}
          placeholder="Select Ageging"
          style={{ width: '100%' }}
           showSearch
                optionFilterProp="label"
        />
         
        {errors.agegingTempTime && <div className="errorField">{errors.agegingTempTime}</div>}
      </div>
      <div className="col-12 py-1">
        <label className="labels">Remarks </label>
<Input.TextArea
  value={remark}
  onChange={(e)=> setRemark(e.target.value)}
  placeholder='Enter Remark'
  maxLength={250}

/>
{errors.remark && <div className="errorField">{errors.remark}</div>}
     </div>
     
  </div>
  </div>)}
  </div>
          {/* Buttons */}
          <div className="col-12 text-center pt-3">
            <Button
              type="submit"
              className="CancelBtn mx-1"
               onClick={handleCancel}
            >
              Cancel
            </Button>
            {submitButton && (
              <Button
                type="submit"
                className="SubmitBtn mx-1"
                 onClick={handleSubmit}
              >
                Submit
              </Button>
            )}
            {completeButton && (
              <Button
                type="submit"
                className="UpdateBtn mx-1"
                       
               onClick={handleCompleteSubmit}
              >
                Complete
              </Button>
            )}
          </div>
  
       
  
    <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div></div>
  
    {/*================ Table =========================*/}
    <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
      <div className="col-12 py-3 shadow border" style={{ backgroundColor: "white" }}>
        <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
            <Select
              defaultValue={pageSize}
              onChange={handlePageSizeChange}
              style={{ width: 120, textAlign: "center" }}
            >
              <Option value={10}>10</Option>
              <Option value={20}>20</Option>
              <Option value={30}>30</Option>
            </Select>
          </div>
  
          <div className="pt-4 pt-md-0">
            <Input.Search
              placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 200, marginBottom: 16 }}
            />
          </div>
        </div>
  
        <div style={{ backgroundColor: "white" }}>
          <Table
            bordered
            style={{ padding: "0px 20px", overflowX: "auto" }}
            columns={columns}
            dataSource={filteredData}
            pagination={{
              pageSize: pageSize,
              total: totalEntries,
              showTotal: (total, range) =>
                `Showing ${range[0]} to ${range[1]} of ${total} entries`,
              current: currentPage,
              onChange: (page) => setCurrentPage(page),
            }}
            showSorterTooltip={false}
            rowKey={(record) => record.id}
            components={components}
          />
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
  </div>
  )
}

export default Ageins